import "./App.css";
import HomePage from "./components/HomePage";
import ChatBotWidget from "./components/ChatBotWidget";

function App() {
  return (
    <div className="App">
      <HomePage />
      <ChatBotWidget />
    </div>
  );
}

export default App;
